﻿export const initUserDetails = () => {

  const userRoleEventHandler = event => {
    const el = event.target as HTMLInputElement;
    userRoleConditionExecuter(el);
  };

  const userRoleConditionExecuter = el => {

    if (el == null) return;

    const rowPartnerSelect = document.getElementById('row-partner-select');
    const hideForRole = rowPartnerSelect.dataset.hideForRole;

    if (el.value == hideForRole || el.value == '') {
      rowPartnerSelect.style.display = "none";
      const partnerSelector = document.getElementById("user-partner-id") as HTMLInputElement;
      partnerSelector.value = '';
    } else {
      rowPartnerSelect.style.display = "table-row";
    }
  }

  const userRoleElement = document.getElementById("user-role-id");
  userRoleElement?.addEventListener("change", userRoleEventHandler);
  userRoleElement?.addEventListener("blur", userRoleEventHandler);
  userRoleConditionExecuter(userRoleElement);
};
